import React, { useEffect, useState } from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { IoIosMenu } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";

const SortableItem = ({ opt, isDrag }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: opt.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="opt-item" {...attributes}>
      <span>{opt.name}</span>
      {isDrag && (
        <button {...listeners}>
          <IoIosMenu />
        </button>
      )}
    </div>
  );
};

const Option = ({ options, setOptions, changeSlide }) => {
  const [activeOpt, setActiveOpt] = useState(null);
  const [cursor, setCursor] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const onDragStart = ({ active, activatorEvent }) => {
    const opt = options.find((o) => o.id === active.id);
    setActiveOpt(opt);
    setIsDragging(true);

    if (activatorEvent && "clientX" in activatorEvent && "clientY" in activatorEvent) {
      setCursor({ x: activatorEvent.clientX, y: activatorEvent.clientY });
    }
  };

  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) {
      cleanup();
      return;
    }

    const oldIndex = options.findIndex((o) => o.id === active.id);
    const newIndex = options.findIndex((o) => o.id === over.id);
    setOptions(arrayMove(options, oldIndex, newIndex));

    cleanup();
  };

  const cleanup = () => {
    setActiveOpt(null);
    setCursor(null);
    setIsDragging(false);
  };

  useEffect(() => {
    const handleMove = (e) => {
      setCursor({ x: e.clientX, y: e.clientY });
    };

    if (isDragging) {
      window.addEventListener("pointermove", handleMove);
    }

    return () => {
      window.removeEventListener("pointermove", handleMove);
    };
  }, [isDragging]);

  return (
    <DndContext collisionDetection={closestCenter} onDragStart={onDragStart} onDragEnd={onDragEnd}>
      <li className="options">
        <span className="tit">옵션</span>
        <div className="cont">
          <button onClick={() => changeSlide(4)} className="setting">
            옵션관리 <IoSettingsOutline />
          </button>
          {options && options.length > 0 && (
            <div className="opt">
              <SortableContext items={options} strategy={verticalListSortingStrategy}>
                {options.map((opt) => (
                  <SortableItem key={opt.id} opt={opt} isDrag={options.length > 1} />
                ))}
              </SortableContext>
            </div>
          )}
        </div>
      </li>
    </DndContext>
  );
};

export default Option;
